import { Exclude, Expose, Type } from 'class-transformer';
import { BaseModel } from '@core/data-access';

@Exclude()
export class StorageUploadLinkFields extends BaseModel {
  /**
   * Using to Upload File to Driver.
   * Generated by Driver Azure or S3.
   */
  @Expose() key!: string;

  @Expose() 'Content-Type'!: string;

  @Expose() bucket!: string;

  /**
   * Have value when Driver is S3
   */
  @Expose() 'X-Amz-Algorithm'!: string;

  /**
   * Have value when Driver is S3
   */
  @Expose() 'X-Amz-Credential'!: string;

  /**
   * Have value when Driver is S3
   */
  @Expose() 'X-Amz-Date'!: string;

  /**
   * Have value when Driver is S3
   */
  @Expose() Policy!: string;

  /**
   * Have value when Driver is S3
   */
  @Expose() 'X-Amz-Signature'!: string;

  /**
   * Have value when Driver is S3
   */
  @Expose() 'X-Amz-Security-Token'!: string;

  /**
   * Have value when Driver is Azure
   */
  @Expose() 'x-ms-blob-type'!: string;

  /**
   * Have value when the file is public
   */
  @Expose() acl!: 'public-read';
}

@Exclude()
export class StorageUploadLink extends BaseModel {
  /**
   * Using to call Upload File API
   */
  @Expose() url!: string;

  @Expose() @Type(() => StorageUploadLinkFields) fields!: StorageUploadLinkFields;

  @Expose() driverName!: 'azure' | 's3';
}
